'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SEARCH_WIDTH_WITH_CATEGORY_MENU = exports.SEARCH_WIDTH_WITH_CATEGORY_MENU = '25.6rem';